import { useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'

import {
  getRetailMediaCounterpartID,
  isAdvertiser,
  isPublisher
} from '~/helpers'
import { useAppInfo } from '~/hooks/useAppInfo'
import { useGetFetchQuery } from '~/hooks/useGetFetchQuery'
import useQueryParams from '~/hooks/useQuery'

import {
  getPaymentTypes,
  getPaymentTypesKey
} from '../services/marketplace/configuration/payment-types/index'

export const usePaymentTypes = () => {
  const { isWhiteLabel } = useAppInfo()
  const publisherId = useQueryParams().get('rmid') as PublisherId
  const requestKey = getRetailMediaCounterpartID()

  const queryKey = [getPaymentTypesKey, requestKey, publisherId]

  const cachedData = useGetFetchQuery<GetPaymentTypesResponse>(queryKey)

  const enabled = useMemo(
    () =>
      isWhiteLabel ||
      (!isWhiteLabel && isAdvertiser() && !!publisherId) ||
      (!isWhiteLabel && isPublisher()),
    [isWhiteLabel, publisherId]
  )

  const {
    data: response = [],
    isPending,
    error
  } = useQuery({
    enabled,
    queryKey,
    queryFn: async () => {
      const params = isWhiteLabel ? undefined : { publisher_id: publisherId }
      const { data } = await getPaymentTypes(params)
      return data
    }
  })

  const data = cachedData || response

  return { isPending: isPending && enabled, data, error, queryKey }
}
